import { ModelBase } from "@shoothill/core";
import { Validator } from "Application/Validation";
import { makeObservable, observable } from "mobx";

export class MentorsModel extends ModelBase<MentorsModel> {
    public current: number = 0;
    public past: number = 0;
    constructor() {
        super();
        makeObservable(this, {
            current: observable,
            past: observable,
        });
    }
}

export class MentorsModelValidator extends Validator<MentorsModel> {
    constructor() {
        super();
    }
}
